/**
 * AEM component wrappers for storage-compliance app.
 * Required by AEMComponentRenderer; empty is correct — this app has no page-specific
 * AEM components (compliance runs in main.tsx). Add wrappers here if a storage-compliance
 * AEM page is later added with custom components.
 */
export const wrappers = [] as const;
